import { PageOrientation } from "docx";
import { FIELD_TYPES } from "../../widgets/fields";
import { languagesData } from "../common/utils/languagesData";

export const CreateFormElements = {
    name: {
        name: "name",
        placeholder: "Enter",
        label: "Form Name",
        isMandatory: true
    },
    description: {
        name: "description",
        placeholder: "Enter",
        label: "Form Description",
        isMandatory: true
    },
    tags: {
        name: "tags",
        placeholder: "Enter",
        label: "Form Tags (Enter Tag and press enter)",
        type: FIELD_TYPES.MULTI_TEXT,
        isMandatory: false
    },
    parent_tag: {
        name: "parent_tag",
        placeholder: "Enter",
        label: "Parent Tag",
        type: FIELD_TYPES.TEXT,
        isMandatory: false
    },
    type: {
        name: "type",
        placeholder: "Select",
        label: "Form Type",
        type: FIELD_TYPES.DROP_DOWN,
        values: [{ label: 'Root', value: 'root' }, { label: 'Level 1', value: 'level1' }, { label: 'Level 2', value: 'level2' }, { label: 'Level 3', value: 'level3' }, { label: 'Level 4', value: 'level4' }, { label: 'Level 5', value: 'level5' }],
        isMandatory: true
    },
    form_usage_type: {
        name: "form_usage_type",
        placeholder: "Select",
        label: "Form usage type",
        type: FIELD_TYPES.MULTI_SELECT,
        isMandatory: false,
        isListed: true
    },
    group: {
        name: "group",
        placeholder: "Select",
        label: "Form Group",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    },
    surveyType: {
        name: "surveyType",
        placeholder: "Select",
        label: "Survey Form",
        type: FIELD_TYPES.DROP_DOWN,
        values: [{ label: 'Yes', value: true }, { label: 'No', value: false }],
        isMandatory: true
    },
    role: {
        name: "role",
        placeholder: "Select",
        label: "",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true,
        menuPlacement: 'top'
    },
    user: {
        name: "user",
        placeholder: "Select",
        label: "",
        type: FIELD_TYPES.DROP_DOWN,
        menuPlacement: 'top'
    },
    startdate: {
        name: "startdate",
        placeholder: "Start Date",
        label: "Start Date",
        type: FIELD_TYPES.DATE_TIME_PICKER,
        isMandatory: false
    },
    enddate: {
        name: "enddate",
        placeholder: "End Date",
        label: "End Date",
        type: FIELD_TYPES.DATE_TIME_PICKER,
        isMandatory: false
    },
    accessType: {
        name: "accessType",
        placeholder: "",
        label: "",
        type: FIELD_TYPES.RADIO_BUTTON,
        values: [{ label: 'Read', value: 'r' }, { label: 'Write', value: 'w' }, { label: 'Forbidden', value: 'f' }],
        isMandatory: true,
        isListed: true
    },
    searchField: {
        name: "searchField",
        placeholder: "Search",
        label: "",
        type: FIELD_TYPES.SEARCH,
        isMandatory: true
    },
    categoryName: {
        name: "categoryName",
        placeholder: "Category Name",
        label: ""
    },
    categoryNameEdit: {
        name: "categoryNameEdit",
        placeholder: "Category Name",
        label: ""
    },
    variables: {
        name: "variables",
        placeholder: "Add Variables",
        label: "",
        type: FIELD_TYPES.MULTI_TEXT,
        isMandatory: true
    },
    strictmode: {
        name: "strict_mode",
        placeholder: "Strict Mode",
        label: "Strict Mode",
        type: FIELD_TYPES.BOOLEAN,
        isMandatory: false
    },
    formTemplate: {
        name: "formTemplate",
        placeholder: "Select",
        label: "Form Template",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: false
    },
    is_localized: {
        name: "is_localized",
        placeholder: "Select",
        label: "",
        type: FIELD_TYPES.RADIO_BUTTON,
        values: [
            { label: 'Yes', value: true },
            { label: 'No', value: false }
        ],
        isListed: true,
    },
    translate: {
        name: "translate",
        placeholder: "Select",
        label: "",
        type: FIELD_TYPES.RADIO_BUTTON,
        values: [
            { label: 'Yes', value: true },
            { label: 'No', value: false }
        ],
        isListed: true,
    },
    language: {
        name: "language",
        placeholder: "Select",
        label: "Language",
        type: FIELD_TYPES.DROP_DOWN,
        values: languagesData,
        isMandatory: true,
    },
    localized_value: {
        name: "localized_value",
        placeholder: "Enter",
        label: "Value",
        type: FIELD_TYPES.TEXT,
        isMandatory: true
    },
    custom_return_message: {
        name: "custom_return_message",
        placeholder: "Enter Custom Message",
        label: `Custom Message (Use ## for new line and ** as separator)`,
        type: FIELD_TYPES.TEXT,
        isMandatory: false
    },
    custom_color_logic: {
        name: "custom_color_logic",
        placeholder: "Enter Custom Color Logic",
        label: `Custom Color Logic (Use Ternary Expression)`,
        type: FIELD_TYPES.TEXT,
        isMandatory: false
    },
    place_holder: {
        name: "place_holder",
        placeholder: "Enter Placeholder",
        label: `Placeholder (Don't use '##' as Placeholder)`,
        type: FIELD_TYPES.TEXT,
        isMandatory: false
    },
    banner_image: {
        name: "banner_image",
        placeholder: "Upload Banner",
        label: "Upload Banner",
        acceptFiles: "png|jpeg|jpg|svg",
        type: FIELD_TYPES.FILE_UPLOAD
    },
    dssd: {
        name: "dssd",
        placeholder: "Select",
        label: "DisAllow Survey Form Submission From Same Device",
        type: FIELD_TYPES.RADIO_BUTTON,
        values: [
            { label: 'Yes', value: true },
            { label: 'No', value: false }
        ],
        isListed: true,
    },
    dssd_number: {
        name: "dssd_number",
        placeholder: "Enter",
        label: "Number of times to allow form submission from same device",
        type: FIELD_TYPES.NUMBER,
        isMandatory: false
    }

};

export const CreateGroupElements = {
    name: {
        name: "name",
        placeholder: "Enter",
        label: "Group Name",
        isMandatory: true
    },
    description: {
        name: "description",
        placeholder: "Enter",
        label: "Group Description",
        isMandatory: true
    },
}
export const CreateVariableElements = {
    fieldName: {
        name: "fieldName",
        placeholder: "Enter",
        label: "Variable Name",
        isMandatory: true
    },
    fieldDescription: {
        name: "fieldDescription",
        placeholder: "Enter",
        label: "Variable Description",
        isMandatory: true
    },
    fieldType: {
        name: "fieldType",
        placeholder: "Select",
        label: "Type",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true,
        isListed: true
    },
    useType: {
        name: "useType",
        placeholder: "Select",
        label: "Use Type",
        type: FIELD_TYPES.MULTI_SELECT,
        isMandatory: true,
        isListed: true
    },
    formuidType: {
        name: "formuidType",
        placeholder: "",
        label: "Form UID Type",
        type: FIELD_TYPES.RADIO_BUTTON,
        values: [{ label: 'Auto', value: 'auto' }, { label: 'Manual', value: 'manual' }],
        isMandatory: true,
        isListed: true
    },
    autoFormFields: {
        name: "autoFormFields",
        placeholder: "",
        label: "Auto UID Fields",
        type: FIELD_TYPES.MULTI_SELECT,
        isMandatory: true,
        isListed: true
    },
    validation: {
        name: "validation",
        placeholder: "Select",
        label: "Validation",
        type: FIELD_TYPES.MULTI_SELECT,
        isListed: true
    },
    validationpopup: {
        name: "validationpopup",
        placeholder: "Select",
        label: "Validation",
        type: FIELD_TYPES.RADIO_BUTTON,
        isListed: true,
        isMandatory: true
    },
    visibility: {
        name: "visibility",
        placeholder: "Select",
        label: "Visibility",
        type: FIELD_TYPES.MULTI_SELECT,
        isListed: true
    },
    timeSeries: {
        name: "timeSeries",
        placeholder: "Select",
        label: "Time Series",
        type: FIELD_TYPES.DROP_DOWN,
        values: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' }
        ],
        isMandatory: true,
        isListed: true,
        menuPlacement: 'top'
    },
    is_localized: {
        name: "is_localized",
        placeholder: "Select",
        label: "",
        type: FIELD_TYPES.RADIO_BUTTON,
        values: [
            { label: 'Yes', value: true },
            { label: 'No', value: false }
        ],
        isListed: true,
    },
    role: {
        name: "role",
        placeholder: "Select",
        label: "",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true,
        menuPlacement: 'top'
    },
    user: {
        name: "user",
        placeholder: "Select",
        label: "",
        type: FIELD_TYPES.DROP_DOWN,
        menuPlacement: 'top'
    },
    accessType: {
        name: "accessType",
        placeholder: "",
        label: "",
        type: FIELD_TYPES.RADIO_BUTTON,
        values: [{ label: 'Read', value: 'r' }, { label: 'Write', value: 'w' }, { label: 'Forbidden', value: 'f' }],
        isMandatory: true,
        isListed: true
    },
    timeStamp: {
        name: "timeStamp",
        placeholder: "HH : MM : SS AA",
        label: "Time Stamp",
        type: FIELD_TYPES.DATE_PICKER,
        isMandatory: false
    },
    prePost: {
        name: "prePost",
        placeholder: "Select",
        label: "Pre / Post",
        type: FIELD_TYPES.DROP_DOWN,
        values: [{ label: 'Before', value: 'before' }, { label: 'After', value: 'after' }, { label: 'Baseline', value: 'baseline' }],
        isMandatory: true,
        menuPlacement: 'top'
    },
    value: {
        name: "value",
        placeholder: "Enter",
        label: "Value",
        inputType: 'number',
        isMandatory: true
    },
    duration: {
        name: "duration",
        placeholder: "Select",
        label: "Duration",
        type: FIELD_TYPES.DROP_DOWN,
        values: [{ label: 'Years', value: 'Y' }, { label: 'Months', value: 'm' }, { label: 'Weeks', value: 'wk' }, { label: 'Days', value: 'd' }, { label: 'Hours', value: 'hr' }, { label: 'Minutes', value: 'min' }, { label: 'Seconds', value: 'sec' }],
        isMandatory: true,
        menuPlacement: 'top'
    },
    language: {
        name: "language",
        placeholder: "Select",
        label: "Language",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true,
    },
    localized_value: {
        name: "localized_value",
        placeholder: "Enter",
        label: "Variable Name",
        type: FIELD_TYPES.TEXT,
        isMandatory: true
    },
    option: {
        name: "option",
        placeholder: "Enter",
        label: "Option",
        isMandatory: true
    },
    scoreFormula: {
        name: "scoreFormula",
        placeholder: "Enter Score Formula",
        label: "Score Formula",
        isMandatory: false
    },
    score: {
        name: "score",
        placeholder: "Enter",
        label: "Score",
        inputType: 'number',
        isMandatory: true
    },
    actions: {
        name: "actions",
        placeholder: "Operation",
        label: "",
        type: FIELD_TYPES.DROP_DOWN,
        values: [
            { label: '>', value: 'greater_than' },
            { label: '>=', value: 'greater_than_equals_to' },
            { label: '<', value: 'less_than' },
            { label: '<=', value: 'less_than_equals_to' },
            { label: '==', value: 'equals_to' },
            { label: 'Contains', value: 'contains' },
            { label: 'Does Not Contains', value: 'does_not_contains' }
        ]
    },
    actionsvariables: {
        name: "actionsvariables",
        placeholder: "Action",
        label: "",
        type: FIELD_TYPES.DROP_DOWN,
        values: [
            { label: 'Skip', value: 'skip_to' },
            { label: 'End', value: 'end' }
        ]
    },
    searchField: {
        name: "searchField",
        placeholder: "Search",
        label: "",
        type: FIELD_TYPES.SEARCH,
        isMandatory: false
    },
    variables: {
        name: "variables",
        placeholder: "Variable Name",
        label: "",
        type: FIELD_TYPES.DROPDOWN_TOOLTIP
    },
    variablesMulti: {
        name: "variablesMulti",
        placeholder: "Select Variables",
        label: "",
        type: FIELD_TYPES.MULTI_SELECT
    },
    searchVariable: {
        name: "searchVariable",
        placeholder: "Add Variable",
        label: "",
        type: FIELD_TYPES.DROP_DOWN
    },
    minValue: {
        name: "minValue",
        placeholder: "Enter",
        label: "Min",
        inputType: 'number',
        isMandatory: true
    },
    maxValue: {
        name: "maxValue",
        placeholder: "Enter",
        label: "Max",
        inputType: 'number',
        isMandatory: true
    },
    rowOption: {
        name: "rowOption",
        placeholder: "Enter",
        label: "Row Option",
        isMandatory: true
    },
    columnOption: {
        name: "columnOption",
        placeholder: "Enter",
        label: "Column Option",
        isMandatory: true
    },
}


export const CreateCriteriaElements = {
    name: {
        name: "name",
        placeholder: "Enter Name",
        label: "Criteria Name",
        isMandatory: false,
    },
    source: {
        name: "source",
        placeholder: "Select",
        label: "Source From",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    },
    destination: {
        name: "destination",
        placeholder: "Select",
        label: "Destination From",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    },
    criteria_type: {
        name: "criteria_type",
        placeholder: "Select",
        label: "Criteria Type",
        type: FIELD_TYPES.DROP_DOWN,
        values: [{ label: 'Intra Project', value: 'intraproject' }, { label: 'Inter Project', value: 'interproject' }],
        isMandatory: true
    },
    project: {
        name: "project",
        placeholder: "Select",
        label: "Project",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    },
    autoapply: {
        name: "autoapply",
        placeholder: "Select",
        label: "Auto Apply",
        type: FIELD_TYPES.DROP_DOWN,
        values: [{ label: "Yes", value: true }, { label: "No", value: false }],
        isMandatory: false
    },
    variable: {
        name: "variable",
        placeholder: "Select",
        label: "Variables",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    },
    operator: {
        name: "operator",
        placeholder: "Select",
        label: "Operator",
        type: FIELD_TYPES.DROP_DOWN,
        values: [{ label: "==", value: "==" },
        { label: "!=", value: "!=" },
        { label: "<", value: "<" },
        { label: ">", value: ">" },
        { label: "<=", value: "<=" },
        { label: ">=", value: ">=" },
        { label: "contains", value: " in " },
        { label: "does not contains", value: " not in " }],
        isMandatory: true
    },
    uservalue: {
        name: "uservalue",
        placeholder: "Select",
        label: "User Value",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    },
    logicoperator: {
        name: "logicoperator",
        placeholder: "Select",
        label: "Logical Operator",
        type: FIELD_TYPES.DROP_DOWN,
        values: [{ label: "AND", value: "and" },
        { label: "OR", value: "or" }],
        isMandatory: true
    },
};

export const CreateRulesElements = {
    name: {
        name: "name",
        placeholder: "Enter Name",
        label: "Criteria Name",
        isMandatory: false,
    },
    source: {
        name: "source",
        placeholder: "Select",
        label: "Source From",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    },
    destination: {
        name: "destination",
        placeholder: "Select",
        label: "Destination From",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    },
    autoapply: {
        name: "autoapply",
        placeholder: "Select",
        label: "Auto Apply",
        type: FIELD_TYPES.DROP_DOWN,
        values: [{ label: "Yes", value: true }, { label: "No", value: false }],
        isMandatory: false
    },
    variable: {
        name: "variable",
        placeholder: "Select",
        label: "Variables",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    },
    operator: {
        name: "operator",
        placeholder: "Select",
        label: "Operator",
        type: FIELD_TYPES.DROP_DOWN,
        values: [{ label: "==", value: "==" },
        { label: "!=", value: "!=" },
        { label: "<", value: "<" },
        { label: ">", value: ">" },
        { label: "<=", value: "<=" },
        { label: ">=", value: ">=" }],
        isMandatory: true
    },
    uservalue: {
        name: "uservalue",
        placeholder: "Select",
        label: "Value Type",
        type: FIELD_TYPES.DROP_DOWN,
        values: [{ label: "Const", value: "const" }, { label: "Var", value: "var" }],
        isMandatory: true
    },
    logicoperator: {
        name: "logicoperator",
        placeholder: "Select",
        label: "Logical Operator",
        type: FIELD_TYPES.DROP_DOWN,
        values: [{ label: "AND", value: "and" },
        { label: "OR", value: "or" }],
        isMandatory: true
    },
    variablesec: {
        name: "variablesec",
        placeholder: "Select",
        label: "Variables",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    }
};


export const SearchPeopleForm = {
    searchby: {
        name: "searchvariables",
        placeholder: "Search",
        label: "",
        type: FIELD_TYPES.DROP_DOWN,
        values: [
            { label: 'All', value: 'all' },
            { label: 'Mentors', value: 'mentors' }
        ]
    },
}

export const ProjectList = {
    fieldType: {
        name: "project",
        placeholder: "Select",
        label: "Select Project",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true,
        isListed: true
    }
}


export const DocTypeList = {
    fieldType: {
        name: "doctypelist",
        placeholder: "Select",
        label: "Select DocType",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true,
        isListed: true
    }
}

export const ReasonFormElements = {
    reason: {
        name: "reason",
        placeholder: "Enter",
        label: "Modify Reason",
        isMandatory: true
    }
}

export const ValidationRulesElements = {
    parentForm: {
        name: "parentForm",
        placeholder: "Select Parent Form",
        label: "Parent Form",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    },
    childForm: {
        name: "childForm",
        placeholder: "Select Child Form",
        label: "Child Form",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    },
    parentFormFields: {
        name: "parentFormFields",
        placeholder: "Select Parent Form Fields",
        label: "Parent Form Fields",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    },
    childFormFields: {
        name: "childFormFields",
        placeholder: "Select Child Form Fields",
        label: "Child Form Fields",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    },
    validation: {
        name: "validation",
        placeholder: "Select Validation",
        label: "Validation",
        type: FIELD_TYPES.DROP_DOWN,
        values: [
            { label: "Date Start", value: "datestart" },
            { label: "Date End", value: "dateend" },
            { label: "Smaller Number", value: "smallernumber" },
            { label: "Larger Number", value: "largernumber" },
            { label: "Value Relationship", value: "value_relationship" },
            { label: "Fixed Values", value: "fixedvalues" },
            { label: "Max Limit", value: "max_limit" },
            { label: "Dependency", value: "dependency" },
            { label: "Life Cycle Check", value: "lifecyclecheck" },
            { label: "Exist Check", value: "exist_check" },
            { label: "sum of child value should not exceed parent value", value: "sum of child value should not exceed parent value" }
        ],
        menuPlacement: 'top',
        isMandatory: true
    },
    value: {
        name: "value",
        placeholder: "Enter Value",
        label: "Value",
        type: FIELD_TYPES.NUMBER,
        isMandatory: true
    },
};

export const AlertRulesElements = {
    form: {
        name: "form",
        placeholder: "Select Form",
        label: "Form",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    },
    formFields: {
        name: "formFields",
        placeholder: "Select Form Fields",
        label: "Form Fields",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    },
    alert: {
        name: "alert",
        placeholder: "Select Alert Type",
        label: "Alert",
        type: FIELD_TYPES.DROP_DOWN,
        values: [
            { label: "Lower Limit", value: "lowerLimit" },
            { label: "Upper Limit", value: "upperLimit" },
            { label: "Equals", value: "equalsTo" },
            { label: "Threshold Range", value: "thresholdRange" },
            { label: "Missing", value: "missing" },
        ],
        menuPlacement: 'top',
        isMandatory: true
    },
    value: {
        name: "value",
        placeholder: "Enter Value",
        label: "Value",
        type: FIELD_TYPES.TEXT,
        isMandatory: true
    },
    minValue: {
        name: "minValue",
        placeholder: "Enter Min Value",
        label: "Min Value",
        type: FIELD_TYPES.NUMBER,
        isMandatory: true
    },
    maxValue: {
        name: "maxValue",
        placeholder: "Enter Max Value",
        label: "Max Value",
        type: FIELD_TYPES.NUMBER,
        isMandatory: true
    },
    alert_category: {
        name: "alert_category",
        placeholder: "Select Alert Category",
        label: "Alert Category",
        type: FIELD_TYPES.MULTI_SELECT,
        values: [
            { label: "Broadcast", value: "broadcast" },
            { label: "Transactional", value: "transactional" },
        ],
        menuPlacement: 'top',
        isMandatory: true
    },
    message_mode: {
        name: "message_mode",
        placeholder: "Select Message Mode",
        label: "Message Mode",
        type: FIELD_TYPES.MULTI_SELECT,
        values: [
            { label: "Email", value: "email" },
            // { label: "SMS", value: "sms" },
            { label: "Whatsapp", value: "whatsapp" },
        ],
        menuPlacement: 'top',
        isMandatory: true
    },
    set_notification: {
        name: "set_notification",
        placeholder: "Select",
        label: "Notification Type",
        type: FIELD_TYPES.MULTI_SELECT,
        values: [
            { label: "Communicate", value: "communicate" },
            { label: "Color", value: "color" }
        ],
        menuPlacement: 'top',
        isListed: true,
    },
    set_colour: {
        name: "set_colour",
        placeholder: "Select Color",
        label: "Select Color",
        type: FIELD_TYPES.DROP_DOWN,
        values: [
            { label: "Red", value: "red" },
            { label: "Yellow", value: "yellow" },
            { label: "Green", value: "green" }
        ],
        menuPlacement: 'top',
        isListed: true,
    },
    target_roles: {
        name: "target_roles",
        placeholder: "Select Roles",
        label: "Target Roles",
        type: FIELD_TYPES.MULTI_SELECT,
        menuPlacement: 'top',
        isMandatory: true
    },
    target_users: {
        name: "target_users",
        placeholder: "Select Users",
        label: "Target Users",
        type: FIELD_TYPES.MULTI_SELECT,
        isMandatory: false
    },
    target_uid_form: {
        name: "target_uid_form",
        placeholder: "Select UID Form",
        label: "Target Uid Form",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true
    },
    target_form_users: {
        name: "target_form_users",
        placeholder: "Select Form Users",
        label: "Target Form Users",
        type: FIELD_TYPES.MULTI_SELECT,
        isMandatory: false
    },
};

export const editRecordsFormElements = {
    variables: {
        name: "variables",
        placeholder: "Select Variables to Edit",
        label: "Variables",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: true,
        isListed: true
    }
}

export const pdfExportFormElements = {
    pageOrientation: {
        name: "pageOrientation",
        placeholder: "Select Page Orientation",
        label: "Page Orientation",
        type: FIELD_TYPES.DROP_DOWN,
        values: [
            { label: "Portrait", value: "portrait" },
            { label: "Landscape", value: "landscape" }
        ],
        isMandatory: true,
        isListed: true
    },
    columnsPerPage: {
        name: "columnsPerPage",
        placeholder: "Select Number of Columns per Page",
        label: "Number of Columns per Page",
        type: FIELD_TYPES.NUMBER,
        isMandatory: true,
        isListed: true
    },
    rowsPerPage: {
        name: "rowsPerPage",
        placeholder: "Select Number of Rows per Page",
        label: "Number of Rows per Page",
        type: FIELD_TYPES.NUMBER,
        isMandatory: true,
        isListed: true
    }
}

export const projectLevelOcrElements = {
    formsMultiSelect: {
        placeholder: "Select Forms",
        label: "Forms",
        type: FIELD_TYPES.MULTI_SELECT,
    },
    pageNoFrom: {
        placeholder: "Enter Page No From",
        label: "From Page",
        type: FIELD_TYPES.NUMBER,
    },
    pageNoTo: {
        placeholder: "Enter Page No To",
        label: "To Page",
        type: FIELD_TYPES.NUMBER,
    },
    is_table: {
        placeholder: "Is Table",
        label: "Is Table",
        type: FIELD_TYPES.RADIO_BUTTON,
        values: [
            { label: 'Table/printed', value: true },
            { label: 'Handwritten/blurry', value: false }
        ],
        isListed: true,
    }
}

export const multiRecordReportElements = {
    report_type: {
        name: "multiRecordReportType",
        type: FIELD_TYPES.RADIO_BUTTON,
        values: [
            { label: 'AI Summary', value: "aiSummary" },
            // { label: 'Printable', value: "printable" }
        ],
    },
    prompt : {
        name : "prompt",
        type: FIELD_TYPES.TEXT_AREA,
        label: "Prompt",
        placeholder: "Enter prompt for AI summary",
        isMandatory: true
    }
}

export const printableTemplateElements = {
    templateTitle: {
        type: FIELD_TYPES.TEXT,
        label: 'Template Title',
        placeholder: 'Enter template title',
        isMandatory: true
    },
    sectionTitle: {
        type: FIELD_TYPES.TEXT,
        label: 'Section Title',
        placeholder: 'Enter section title',
        isMandatory: true
    },
    formSelect: {
        type: FIELD_TYPES.DROP_DOWN,
        label: 'Select Form',
        placeholder: 'Choose a form',
        menuPlacement: 'top',
        isMandatory: true
    },
    printableTemplate : {
        name : "printableTemplate",
        type: FIELD_TYPES.DROP_DOWN,
        label: 'Select Template',
        placeholder: 'Choose a Template',
        menuPlacement: 'top',
        isMandatory: true
    }
};